import { useSyncExternalStore } from "react";

import type { Crumb } from "@/mk/types";

/** What a screen adds to the breadcrumb under its application, such as the
 *  folder it is showing; cleared when the screen goes away. */
let current: Crumb[] = [];
const listeners = new Set<() => void>();

export function setPageTrail(next: Crumb[]) {
    current = next;
    listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void) {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
}

export function usePageTrail(): Crumb[] {
    return useSyncExternalStore(subscribe, () => current);
}
